// TODO: remove eslint disable
/* eslint-disable */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
// import { useDetectAdBlock } from "adblock-detect-react";
import { useAdBlockDetector } from "adblock-detector-hook";
import useLocalStorage from "../../../hooks/useLocalStorage";

import * as router from "../../../router/routes";
import SVG, { LogoIcon } from "../../SVG";
import { Button, Modal, ModalView as AdBlockModal } from "../../simple";

import Api from "../../../api";
import { AccessControl, permissions } from "../../permissions";
import HelpDesk from "./HelpDeskRow";
import styles from "../../../screens/Account/AccountProfile/account-profile.module.scss";
import Invite from "../../forms/Auth/Invite";

const SideBarNavigation = props => {
  // const adBlockDetected = useDetectAdBlock();
  const { detected: adBlockDetected } = useAdBlockDetector();
  const {
    closeModal,
    openModal,
    inviteHandler,
    onInviteError,
    showModal,
    requestError
  } = useInviteModal();
  const [isAdBlockTurnedOn, setIsAdBlockTurnedOn] = useLocalStorage(
    "isAdBlockTurnedOn",
    false
  );

  const [isShowAdBlockModal, setIsShowAdBlockModal] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (adBlockDetected && isAdBlockTurnedOn) {
        return;
      }

      if (adBlockDetected && !isAdBlockTurnedOn) {
        setIsAdBlockTurnedOn(true);
        setIsShowAdBlockModal(true);
      } else setIsAdBlockTurnedOn(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, [adBlockDetected, isAdBlockTurnedOn, setIsAdBlockTurnedOn]);

  const { user } = props;
  const inStorageState = JSON.parse(localStorage.getItem("sidebar-expanded"));
  const typeSubscribe = "Expert";
  const initialState =
    inStorageState === null || inStorageState === undefined
      ? true
      : !!inStorageState;
  const [expanded, setShrink] = useState(initialState);
  const changeState = () => {
    localStorage.setItem("sidebar-expanded", !expanded);
    setShrink(!expanded);
  };

  // useEffect(() => {
  //   if (Object.keys(user).length === 0) {
  //     console.log("SIDEBAR Api.user.getUserInfo(); called")
  //     Api.user.getUserInfo();
  //   }
  // }, [user]);

  const handleCloseAdBlockModal = () => {
    setIsShowAdBlockModal(false);
  };

  return (
    <>
      <nav id="sidebar" className={`${expanded ? "" : "collapsed"} `}>
        <div className="sidebar-header">
          <Link to={router.guide}>
            {user.company?.logo &&
            typeSubscribe === user.company?.currentSubscription ? (
              <img
                src={user.company?.logo}
                alt="LogoIcon"
                className={`logo-image ${!expanded ? "logo_sm" : "logo_lg"}`}
              />
            ) : (
              <LogoIcon collapsed={!expanded} />
            )}
          </Link>
          {/*<Button type="button" className="collapser" onClick={changeState}>*/}
          {/*  <SVG.Arrow stroke="#11161F" fill="#11161F" />*/}
          {/*</Button>*/}
        </div>
        <ul className="list-unstyled components">
          <AccessControl allow={permissions.clientSection.view}>
            <li>
              <NavLink to={router.clients("")} activeClassName="active">
                <SVG.Client /> <span>Clients</span>
              </NavLink>
            </li>
          </AccessControl>

          <li>
            <NavLink to={router.audiences("")}>
              <SVG.Audience fill="#fff" /> <span>Audiences</span>
            </NavLink>
          </li>
          {/* TODO: add AdminAccessControl component */}
          {user.role === "gdr admin" && (
            <li>
              <NavLink to={router.crm}>
                <SVG.Settings /> <span>CRM</span>
              </NavLink>
            </li>
          )}
          {/* <li>
          <NavLink to={router.report}>
            <SVG.Report /> <span>report</span>
          </NavLink>
        </li> */}
        </ul>
        <div className="sidebar-footer">
          <ul className="list-unstyled components">
            <li>
              <NavLink
                className="logout-button"
                // style={{
                // display: "flex",
                // width: "100%",
                // textAlign: "right",
                // marginRight: 0,
                // }}
                to={router.trash}
              >
                <SVG.Trash width={15} height={20} fill="#424f62" />
                <span>Trash</span>
              </NavLink>
            </li>
          </ul>
          <HelpDesk />
          <li>
            <div
              className={"logout-button"}
              // target={"_blank"}
              onClick={openModal}
              // to={"invite"}
            >
              <PlusSVGIcon />
              <span>Invite People</span>
            </div>
          </li>
          <Button
            type="button"
            onClick={() => Api.auth.logOut()}
            className="logout-button"
          >
            <SVG.LogOut />
            <span>Log Out</span>
          </Button>
        </div>
      </nav>
      <Modal
        centered
        className={styles["modal-invite"]}
        contentClassName={styles["modal-content"]}
        isOpen={showModal}
        toggle={closeModal}
      >
        <Invite
          setError={onInviteError}
          error={requestError}
          handleSubmit={data => inviteHandler(data)}
          user={user}
        />
        <SVG.Close
          className={`${styles["close-modal"]}`}
          onClick={closeModal}
        />
      </Modal>
      <AdBlockModal
        isOpen={isShowAdBlockModal}
        toggle={() => {
          setIsShowAdBlockModal(prevState => !prevState);
        }}
        handleClose={handleCloseAdBlockModal}
      >
        <div className="d-flex justify-content-center mb-5">
          <SVG.Fail width={168} height={168} />
        </div>
        <h2 className="title text-center mb-3">AdBlock Detected</h2>
        <p
          className="description mb-3 text-center"
          style={{ lineHeight: "1.5" }}
        >
          We are not serving ads, but your ad-blocker will prohibit our app and
          the pushes to other platforms
          <br />
          to work properly. Please turn your blocker when
          <br />
          using our application
        </p>
        <div className="buttons-container">
          <Button
            onClick={handleCloseAdBlockModal}
            className="btn button justify-content-center ml-auto mr-auto mt-4 mb-2"
          >
            Continue
          </Button>
        </div>
      </AdBlockModal>
    </>
  );
};

SideBarNavigation.propTypes = {
  user: PropTypes.shape({
    company: PropTypes.object
  }).isRequired
};

const mapStateToProps = props => {
  const { userProfile } = props;
  return {
    user: userProfile.user
  };
};

export default connect(mapStateToProps, null)(SideBarNavigation);

const PlusSVGIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1V19M19 10L1 10"
      stroke="#FEFFFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function useInviteModal() {
  const [showModal, setShowModal] = useState(false);
  const [requestError, setRequestError] = useState(null);
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const onInviteError = error => {
    setRequestError(error);
  };

  const inviteHandler = async ({ emails, role, message }) => {
    try {
      const emailList = emails.filter(email => !!email);
      await Api.user.invite({
        data: {
          role,
          emailList,
          message
        }
      });
      closeModal();
    } catch (err) {
      if (err.response) {
        const { data } = err.response;
        onInviteError(data);
      } else {
        onInviteError("Something went wrong!");
      }
    }
  };
  return {
    inviteHandler,
    onInviteError,
    showModal,
    closeModal,
    openModal,
    requestError
  };
}
